import React from "react";

const TalentTeamWelcome = ({ onClick, actionButtonText = "Don't Show this Again" }) => {
    return (
        <div className="p-2 md:px-4 md:py-10">

            <div className="px-4 py-8 bg-white max-w-4xl m-auto lg:p-12">

                <h1 className="text-3xl font-bold">Introducing Teams</h1>

                <img src="/images/heads.png" className="my-8 lg:my-20 m-auto" alt="" />

                <p className="text-wripplePrimaryDarkNavy">
                    Form teams to deliver projects with people you already know and love working with.
                </p>

                <div className="my-8">

                    <h3 className="text-primary text-xl mb-2">
                        Expand Your Freelance Network
                    </h3>

                    <p className="text-wripplePrimaryDarkNavy">
                        Find other freelancers in the Wripple community to help strengthen your network and work together to propose for new opportunities.
                    </p>
                </div>

                <div className="my-8">
                    <h3 className="text-primary text-xl mb-2">
                        Bring Your Own Talent
                    </h3>

                    <p className="text-wripplePrimaryDarkNavy">
                        Invite freelancers you have worked with before to deliver for larger project scopes and requirements
                    </p>
                </div>

                <div className="flex justify-center pt-12">
                    <button className="btn btn-primary text-sm w-1/2" onClick={onClick}>
                        {actionButtonText}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TalentTeamWelcome;